// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './common/css/index.scss'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import MessageBox from './common/vue/myMassageBox';
import 'babel-polyfill';
import i18n from './lang/lang'

// import vConsole from './common/js/vconsole';
// Vue.use(vConsole)

// Vue.use(VueI18n);
Vue.component('message-box', MessageBox);

Vue.use(MintUI)
Vue.config.productionTip = false

// const messages = {
//   en: {}
// }

i18n.locale = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js